var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisibility, width: "30%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibility = $event
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("strong", [_vm._v("Device ")]),
        _vm._v(
          _vm._s(_vm.device.mac_address || _vm.device.hardware_id) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "font-size": "initial" } },
        [
          _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
            _vm._v("\n      Redirecting to "),
            _c("strong", [_vm._v("Ring Solutions")]),
            _vm._v(" in "),
            _c("strong", [_vm._v(_vm._s(_vm.timer))]),
            _vm._v(" seconds\n    "),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.openNewTab } },
            [
              _c("span", { staticStyle: { "font-size": "initial" } }, [
                _vm._v("cancel and open in a new tab"),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info", size: "medium" },
              on: { click: _vm.cancel },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }